const decodeLookup = (lookup) => lookup
    ? {
        displayColumn: lookup.display_column,
        fileName: lookup.file_name,
        lookupId: lookup.lookup_id,
        rowCount: lookup.row_count,
        searchColumn: lookup.search_column,
        valueColumn: lookup.value_column,
        valueOptions: lookup.value_options ?? []
    }
    : undefined;
const encodeLookup = (lookup) => lookup
    ? {
        display_column: lookup.displayColumn,
        file_name: lookup.fileName,
        lookup_id: lookup.lookupId,
        row_count: lookup.rowCount,
        search_column: lookup.searchColumn,
        value_column: lookup.valueColumn,
        value_options: lookup.valueOptions
    }
    : undefined;
export const decodeProjectPolicyQuestion = (question) => {
    return {
        archived: question.archived,
        created: new Date(question.created),
        evOn: question.ev_on,
        familyId: question.family_id,
        flagged: question.flagged ?? [],
        fmt: question.fmt,
        help: question.help,
        id: question.project_policy_question_id,
        kind: question.kind,
        lookup: decodeLookup(question.lookup),
        options: question.options ?? [],
        projectId: question.project_id,
        projectPolicyId: question.project_policy_id,
        questionText: question.question_text,
        required: question.required,
        revision: question.revision,
        sortOrder: question.sort_order
    };
};
export const encodeProjectPolicyQuestion = (question) => {
    return {
        archived: question.archived,
        created: question.created,
        ev_on: question.evOn,
        family_id: question.familyId,
        flagged: question.flagged,
        fmt: question.fmt,
        help: question.help,
        kind: question.kind,
        lookup: encodeLookup(question.lookup),
        options: question.options,
        project_id: question.projectId,
        project_policy_id: question.projectPolicyId,
        project_policy_question_id: question.id,
        question_text: question.questionText,
        required: question.required,
        revision: question.revision,
        sort_order: question.sortOrder
    };
};
